import { apiFetch, lerAuth, salvarAuth, limparAuth } from './apiClient';

export async function login(email, senha) {
  const data = await apiFetch('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, senha }),
  });
  salvarAuth({ token: data.token, usuario: data.usuario });
  /* permissões já na entrada: sem isso a 1ª tela usava o cache de quem
     entrou antes neste navegador (ex.: equipe -> usuário de cliente) */
  try {
    localStorage.setItem('erp_perm', JSON.stringify(await apiFetch('/permissoes/me')));
  } catch {
    try { localStorage.removeItem('erp_perm'); } catch { /* sem storage */ }
  }
  return data.usuario;
}

export function usuarioLogado() {
  return lerAuth()?.usuario ?? null;
}

function tokenExpirado(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return !payload.exp || Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

export function estaLogado() {
  const auth = lerAuth();
  return !!auth?.token && !tokenExpirado(auth.token);
}

/* editar o próprio nome/setor -- qualquer usuário pode, sem precisar de
   privilégio de admin (equivalente ao antigo supabase.auth.updateUser) */
export async function atualizarMeuPerfil({ nome, setor }) {
  const data = await apiFetch('/usuarios/me', {
    method: 'PATCH',
    body: JSON.stringify({ nome: nome?.trim() || '', setor: setor?.trim() || '' }),
  });
  const auth = lerAuth();
  if (auth) salvarAuth({ ...auth, usuario: { ...auth.usuario, nome: data.nome, setor: data.setor } });
  return data;
}

/* trocar a própria senha -- exige a senha atual. Não existia nenhuma forma
   de fazer isso antes (era resolvido fora do app, no painel do Supabase). */
export async function alterarMinhaSenha({ senhaAtual, novaSenha }) {
  await apiFetch('/usuarios/me/senha', {
    method: 'PATCH',
    body: JSON.stringify({ senhaAtual, novaSenha }),
  });
}

export function logout() {
  limparAuth();
  try { localStorage.removeItem('erp_perm'); } catch { /* sem storage */ }
}
